// @flow
import React from "react";
import { theme } from "../theme";

const transform = (inverted) =>
  inverted ? "scale(1, -1) translate(0, -16)" : "";

type Props = {
  className: string,
  inverted: boolean,
  fill?: string,
};

// This is the raw SVG version of the design from Zeplin
export const Arrow = ({
  className,
  inverted,
  fill = theme.palette.navy.dark,
}: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
  >
    <path
      transform={transform(inverted)}
      fill={fill}
      fillRule="nonzero"
      d="M7.989 9.164L4.297 5.229a.75.75 0 1 0-1.094 1.026l4.237 4.516a.75.75 0 0 0 1.092.002l4.263-4.516a.75.75 0 1 0-1.09-1.03L7.989 9.164z"
    />
  </svg>
);
